export function setWebpackPublicPath(publicPath: string) {
  __webpack_public_path__ = publicPath
}
